import TrackerDataTableItemEdit from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableItemEdit/TrackerDataTableItemEdit.vue'
import TrackerDataTableItemTitle from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableItemTitle/TrackerDataTableItemTitle.vue'

export default {
  name: 'OpportunityTableEdit',
  mixins: [TrackerDataTableItemEdit],

  components: {
    TrackerDataTableItemTitle
  }
}
